module.exports = __webpack_public_path__ + "img/fibraConcreto2.2f3b1fb6.png";